export const mockBooks = [
  {
    id: '1',
    title: 'Bee Wise, Money Wise',
    subtitle: 'Adventures in Earning and Saving',
    author: 'Chris Dymalovski',
    coverImage: '/books/covers/saving-01.png',
    price: 14.99,
    ageRange: '6-10 years',
    pages: 75,
    category: 'Financial Literacy',
    description: 'Join Professor Bee on an exciting adventure to learn about earning, saving, and the value of money! Through thrilling quests and puzzles, young readers discover financial wisdom hidden in every page.',
    featured: true,
    rating: 4.8,
    reviews: 127,
    themes: ['Money Management', 'Savings', 'Financial Wisdom'],
    sample: [
      { page: 1, content: 'Chapter 1: The Golden Honeycomb', illustration: '/books/covers/saving-01.png' },
      { page: 2, content: 'Professor Bee looked at the shimmering honeycomb...', illustration: '/books/covers/saving-01.png' }
    ]
  },
  {
    id: '2',
    title: 'The Green Quest',
    subtitle: 'James and Belinda\'s Adventure',
    author: 'Chris Dymalovski & Belinda Flaherty',
    coverImage: '/books/covers/recycling-01.png',
    price: 14.99,
    ageRange: '6-10 years',
    pages: 63,
    category: 'Environmental Science',
    description: 'Follow James and Belinda as they embark on a thrilling quest to save the planet! Learn about recycling, nature, and environmental care through an action-packed adventure.',
    featured: true,
    rating: 4.9,
    reviews: 156,
    themes: ['Recycling', 'Environment', 'Conservation'],
    sample: [
      { page: 1, content: 'Chapter 1: The Mysterious Green Signal', illustration: '/books/covers/recycling-01.png' }
    ]
  },
  {
    id: '3',
    title: 'Guardians of the Web',
    subtitle: 'A Digital Safety Adventure',
    author: 'Chris Dymalovski & Belinda Flaherty',
    coverImage: '/books/covers/web_guardians-01.png',
    price: 12.99,
    ageRange: '8-12 years',
    pages: 32,
    category: 'Digital Safety',
    description: 'Enter the digital realm with brave guardians who protect the internet! Learn about online safety, digital citizenship, and cyber awareness through this thrilling adventure.',
    featured: false,
    rating: 4.7,
    reviews: 89,
    themes: ['Internet Safety', 'Digital Literacy', 'Cybersecurity'],
    sample: [
      { page: 1, content: 'Chapter 1: The Portal Opens', illustration: '/books/covers/web_guardians-01.png' }
    ]
  },
  {
    id: '4',
    title: 'Professor Bee\'s Body Expedition',
    subtitle: 'A Journey Through the Human Body',
    author: 'Chris Dymalovski & Belinda Flaherty',
    coverImage: '/books/covers/the_body-01.png',
    price: 14.99,
    ageRange: '7-11 years',
    pages: 58,
    category: 'Human Biology',
    description: 'Shrink down to microscopic size with Professor Bee and explore the amazing human body! Discover how organs work, what bones do, and unlock the secrets of health and wellness.',
    featured: true,
    rating: 4.9,
    reviews: 203,
    themes: ['Human Body', 'Health', 'Biology'],
    sample: [
      { page: 1, content: 'Chapter 1: The Shrinking Machine', illustration: '/books/covers/the_body-01.png' }
    ]
  }
];

export const mockBlogPosts = [
  {
    id: '1',
    title: 'How to Make Learning Fun for Young Explorers',
    excerpt: 'Discover proven strategies to turn education into exciting adventures that keep children engaged and curious.',
    author: 'Learning Smart Team',
    date: '2025-01-15',
    category: 'Parenting Tips',
    image: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800',
    readTime: '5 min read'
  },
  {
    id: '2',
    title: 'The Science Behind Story-Based Learning',
    excerpt: 'Why do children learn better through stories? Explore the cognitive science that makes our adventure books so effective.',
    author: 'Dr. Sarah Mitchell',
    date: '2025-01-10',
    category: 'Educational Research',
    image: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=800',
    readTime: '7 min read'
  },
  {
    id: '3',
    title: 'Top 5 Activities to Complement Your Adventure Books',
    excerpt: 'Extend the learning beyond the pages with these creative activities that reinforce key concepts.',
    author: 'Chris Dymalovski',
    date: '2025-01-05',
    category: 'Activities',
    image: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=800',
    readTime: '4 min read'
  }
];

export const mockActivities = [
  {
    id: '1',
    title: 'Money Math Challenge',
    description: 'Fun worksheets to practice counting, saving, and budgeting with Professor Bee!',
    category: 'Financial Literacy',
    ageRange: '6-10 years',
    downloadUrl: '#',
    thumbnail: '/books/covers/saving-01.png',
    downloads: 2340
  },
  {
    id: '2',
    title: 'Recycling Scavenger Hunt',
    description: 'An outdoor adventure to identify recyclable materials around your home and neighborhood.',
    category: 'Environmental Science',
    ageRange: '6-10 years',
    downloadUrl: '#',
    thumbnail: '/books/covers/recycling-01.png',
    downloads: 1876
  },
  {
    id: '3',
    title: 'Internet Safety Quiz',
    description: 'Test your digital safety knowledge with this interactive quiz for young web guardians!',
    category: 'Digital Safety',
    ageRange: '8-12 years',
    downloadUrl: '#',
    thumbnail: '/books/covers/web_guardians-01.png',
    downloads: 1523
  },
  {
    id: '4',
    title: 'Body Systems Puzzle',
    description: 'Match organs, learn their functions, and complete the human body puzzle!',
    category: 'Biology',
    ageRange: '7-11 years',
    downloadUrl: '#',
    thumbnail: '/books/covers/the_body-01.png',
    downloads: 2109
  }
];

export const mockTestimonials = [
  {
    id: '1',
    name: 'Sarah Johnson',
    role: 'Parent of 2',
    avatar: 'https://i.pravatar.cc/150?img=1',
    rating: 5,
    text: 'My kids are obsessed with these books! They don\'t even realize they\'re learning. The adventures are so engaging that bedtime reading has become their favorite part of the day.'
  },
  {
    id: '2',
    name: 'Michael Chen',
    role: '3rd Grade Teacher',
    avatar: 'https://i.pravatar.cc/150?img=2',
    rating: 5,
    text: 'I use Learning Smart in my classroom and the results are incredible. Students are excited to learn about science, money, and the environment. These books are game-changers!'
  },
  {
    id: '3',
    name: 'Emily Rodriguez',
    role: 'Homeschool Mom',
    avatar: 'https://i.pravatar.cc/150?img=3',
    rating: 5,
    text: 'Perfect for homeschooling! The combination of storytelling and education keeps my daughter engaged for hours. The activities complement the books beautifully.'
  }
];

export const mockCart = [];

export const mockOrders = [];